import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6971a36e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MainProfile" }
const _hoisted_2 = { class: "TopSection" }
const _hoisted_3 = { style: {"margin-top":"70px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "DownSection" }
const _hoisted_7 = { class: "InformationsSection" }
const _hoisted_8 = {
  key: 0,
  class: "SectionData"
}
const _hoisted_9 = {
  key: 1,
  class: "SectionData"
}
const _hoisted_10 = {
  key: 2,
  class: "SectionData"
}
const _hoisted_11 = {
  key: 3,
  class: "SectionData"
}
const _hoisted_12 = {
  key: 4,
  class: "SectionData"
}
const _hoisted_13 = {
  key: 5,
  class: "SectionData"
}
const _hoisted_14 = {
  key: 6,
  class: "SectionData"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_16 = {
  key: 7,
  class: "SectionData"
}
const _hoisted_17 = {
  key: 8,
  class: "SectionData"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_19 = { class: "Tabs" }
const _hoisted_20 = {
  class: "BigHeader",
  style: {}
}
const _hoisted_21 = { class: "ContinerTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesTabs = _resolveComponent("CookiesTabs")!
  const _component_CookiesFunctionalTable = _resolveComponent("CookiesFunctionalTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "EmployeeImge",
        style: _normalizeStyle('background-image: url(' + _ctx.DefaultImageHandler(_ctx.Employee.ImgUrl, _ctx.$store.state.CookiesConfig.UserImage) + ');')
      }, null, 4),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.Employee.Name)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.Employee.Name), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.Position)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.Employee.Department?.Name) + " - " + _toDisplayString(_ctx.Employee.Position?.Name), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.Employee.ID)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.Translate('ID : ' + '  ' + _ctx.Employee.ID )), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.HireDate)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.Translate('Employeed from' + '  ' + _ctx.Employee.HireDate )), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.Department?.Name)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.Translate('Department :' + '  ' + _ctx.Employee.Department?.Name )), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.Gender)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.Translate('Gender : ' + '  ' +  _ctx.Employee.Gender )), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.Nationality?.Name)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(_ctx.Translate('Nationality : ' + '  ' +  _ctx.Employee.Nationality?.Name )), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.BirthDate)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_13, _toDisplayString(_ctx.Translate('Birth Date : ' + '  ' +  _ctx.Employee.BirthDate )), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.Shift?.Name)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_14, _toDisplayString(_ctx.Translate('Shift : ' + '  ' +  _ctx.Employee.Shift?.Name )), 1))
          : _createCommentVNode("", true),
        _hoisted_15,
        (_ctx.Employee.Email)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_16, _toDisplayString(_ctx.Translate('Email')) + ": " + _toDisplayString(_ctx.Employee.Email), 1))
          : _createCommentVNode("", true),
        (_ctx.Employee.PhoneNumber)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_17, _toDisplayString(_ctx.Translate('Phone')) + ": " + _toDisplayString(_ctx.Employee.PhoneNumber), 1))
          : _createCommentVNode("", true),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_CookiesTabs, {
            Tabs: _ctx.Tabs,
            Default: (_ctx.Tabs[0] as CookiesTabs),
            Router: false,
            Res: 'ChosenTab'
          }, null, 8, ["Tabs", "Default"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_ctx.MEMRead('ChosenTab')?.Value == 'Attendance')
            ? (_openBlock(), _createBlock(_component_CookiesFunctionalTable, {
                key: 0,
                style: {"height":"100%"},
                onEditAttendance: _ctx.EditAttendance,
                onDeleteAttendance: _ctx.DeleteAttendance,
                CookiesData: _ctx.CookiesDataAttendance,
                Loading: _ctx.Loading,
                TableSettings: _ctx.TableSettingsAttendance
              }, null, 8, ["onEditAttendance", "onDeleteAttendance", "CookiesData", "Loading", "TableSettings"]))
            : _createCommentVNode("", true),
          (_ctx.MEMRead('ChosenTab')?.Value == 'Requests')
            ? (_openBlock(), _createBlock(_component_CookiesFunctionalTable, {
                key: 1,
                style: {"height":"100%"},
                CookiesData: _ctx.CookiesDataAttendanceRequests,
                Loading: _ctx.Loading,
                TableSettings: _ctx.TableSettingsAttendanceRequests
              }, null, 8, ["CookiesData", "Loading", "TableSettings"]))
            : _createCommentVNode("", true),
          (_ctx.MEMRead('ChosenTab')?.Value == 'Warnings')
            ? (_openBlock(), _createBlock(_component_CookiesFunctionalTable, {
                key: 2,
                style: {"height":"100%"},
                CookiesData: _ctx.CookiesDataWarnings,
                Loading: _ctx.Loading,
                TableSettings: _ctx.TableSettingsWarnings
              }, null, 8, ["CookiesData", "Loading", "TableSettings"]))
            : _createCommentVNode("", true),
          (_ctx.MEMRead('ChosenTab')?.Value == 'Deductions')
            ? (_openBlock(), _createBlock(_component_CookiesFunctionalTable, {
                key: 3,
                style: {"height":"100%"},
                CookiesData: _ctx.CookiesDataDeductions,
                Loading: _ctx.Loading,
                TableSettings: _ctx.TableSettingsDeductions
              }, null, 8, ["CookiesData", "Loading", "TableSettings"]))
            : _createCommentVNode("", true),
          (_ctx.MEMRead('ChosenTab')?.Value == 'Payroll')
            ? (_openBlock(), _createBlock(_component_CookiesFunctionalTable, {
                key: 4,
                style: {"height":"100%"},
                CookiesData: _ctx.CookiesDataPayrollItems,
                Loading: _ctx.Loading,
                TableSettings: _ctx.TableSettingsPayrollItems
              }, null, 8, ["CookiesData", "Loading", "TableSettings"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}